import { observer } from 'src/utils/mobx-react';
import { ActionDropdown } from 'src/components/ActionDropdown/ActionDropdown';
import { SelectWrapper } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/components/SelectWrapper';
import React from 'react';
import {
    CompetitionPreview,
    CompetitionsPreview,
    LiabilitiesFiltersProps,
    Sports,
} from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/LiabilitiesFilters.types';
import { buildFormCallback } from 'src/domains/sportsbook/trading/view/Liabilities/LiabilitiesFilters/LiabilitiesFilters.helpers';
import { fromJS } from 'immutable';

type CompetitionsFilterPropsType = Pick<LiabilitiesFiltersProps, 'onChange'> & {
    competition?: number | null;
    competitions: CompetitionsPreview;
    sports: Sports;
    addCompetition: (competition: CompetitionPreview) => void;
};

export const CompetitionsFilter = observer(
    'CompetitionsFilter',
    ({ competitions, competition, sports, onChange, addCompetition }: CompetitionsFilterPropsType) => {
        const handleChange = (competition: unknown): void => {
            if (typeof competition === 'number' || competition === null) {
                onChange('competition', competition);
            }
        };

        const title = 'Select Competition';
        const searchPromptText = 'Type to search competition';

        // TODO: Remove immutable transformation when CompetitionForm is refactored
        const immutableSportsForCompetitionForm = fromJS(sports);

        return (
            <div className='col-2'>
                <SelectWrapper label={title}>
                    <ActionDropdown
                        name={title}
                        label={title}
                        clearable
                        ignoreCase
                        noResultsText='No competitions found'
                        value={competition}
                        onChange={handleChange}
                        options={competitions}
                        searchable
                        className='dropdown-select-form select-has-btn'
                        searchPromptText={searchPromptText}
                        trimFilter
                        // @ts-expect-error
                        onAdd={addCompetition}
                        // @ts-expect-error
                        getAddForm={buildFormCallback({
                            sports: immutableSportsForCompetitionForm,
                        })}
                        isShorten={true}
                    />
                </SelectWrapper>
            </div>
        );
    }
);
